const MutationTypes = {
  SET_WORKSPACE_ID: 'SET_WORKSPACE_ID',
  SET_LAST_SESSION_ID: 'SET_LAST_SESSION_ID',
  SET_WORKSPACE: 'SET_WORKSPACE',
  SET_EMAIL: 'auth/SET_EMAIL',
}

export default MutationTypes
